import classNames from 'classnames';
import { memo, useCallback, useState } from 'react';

import { type Board } from '@air/api/types';

import { GalleryBoardThumbnail } from '~/components/v2/components/shared/gallery/GalleryBoardThumbnail';
import { BOARD_DRAG_PREVIEW_HEIGHT, BOARD_DRAG_PREVIEW_WIDTH } from '~/constants/dnd';

export type DndBoardDragPreviewProps = {
  board: Board;
  height?: number;
};

export const DNDBoardGalleryCardDragPreview = memo(
  ({ board, height = BOARD_DRAG_PREVIEW_HEIGHT }: DndBoardDragPreviewProps) => {
    const [hasValidThumbnail, setHasValidThumbnail] = useState(false);

    const handleFallbackChange = useCallback((isFallback: boolean) => {
      setHasValidThumbnail(!isFallback);
    }, []);

    return (
      <div className="relative size-full rounded-12 bg-grey-1 p-1 ring-1 ring-grey-5 ring-inset">
        <GalleryBoardThumbnail
          board={board}
          box={{ height, width: BOARD_DRAG_PREVIEW_WIDTH }}
          sizes="240px"
          onFallbackChange={handleFallbackChange}
        />
        <div
          className={classNames(
            'pointer-events-none absolute inset-x-1 bottom-1 z-20 flex flex-col items-start gap-0.5 rounded-b-8 bg-transparent px-2 pt-6 pb-2',
            hasValidThumbnail && 'bg-gradient-to-t from-black/70 to-transparent',
          )}
        >
          <span
            className={classNames(
              'line-clamp-2 font-semibold text-16 leading-5',
              hasValidThumbnail ? 'text-white' : 'text-grey-11',
            )}
            style={hasValidThumbnail ? { textShadow: '0px 0px 4px rgba(0, 0, 0, 0.40)' } : undefined}
          >
            {board.title}
          </span>
        </div>
      </div>
    );
  },
);

DNDBoardGalleryCardDragPreview.displayName = 'DNDBoardGalleryCardDragPreview';
